import { Navigate } from "react-router-dom";
import C1ListPanel from "app/c1component/C1ListPanel";
import C1EmptyState from "app/c1component/FeedbackAndStates/C1EmptyState";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { moduleAdminOverviewSegments } from "../../shared/adminRouteSegments";
import { useModuleAdminAccess } from "./useModuleAdminAccess";

/**
 * OPS-MODULE-ADMIN-STABILIZATION-003 — page ACL gate for module admin routes.
 */
export default function ModuleAdminRouteGuard({ children }) {
  const { hasPageReadAccess } = useModuleAdminAccess();

  if (!hasPageReadAccess) {
    return (
      <C1ListPanel routeSegments={moduleAdminOverviewSegments}>
        <C1EmptyState
          icon={<LockOutlinedIcon />}
          title="Access denied"
          description="User Role Assignment read access is required to manage module users."
          severity="warning"
        />
      </C1ListPanel>
    );
  }

  return children;
}

export function ModuleAdminDetailRouteGuard({ moduleKey, children }) {
  const { hasPageReadAccess, canManageModule } = useModuleAdminAccess();
  const normalizedKey = String(moduleKey || "").trim().toUpperCase();

  if (!hasPageReadAccess) {
    return <Navigate to="/not-authorized" replace />;
  }

  if (normalizedKey && !canManageModule(normalizedKey)) {
    return <Navigate to="/users/manage-roles" replace />;
  }

  return children;
}
